<template>
  <v-card
    class="mx-auto customPos pa-0"
    max-width="300"
    :class="{ expanded: isExpanded }"
  >
    <!-- <div class="bold-text">Layers</div> -->
    <v-card-text v-show="isExpanded" class="pb-0">
      <v-checkbox
        v-model="checkbox0"
        :label="`1648 Political Boundary`"
      ></v-checkbox>
      
      <v-checkbox
        v-model="checkbox1"
        :label="`Political`"
      ></v-checkbox>

      <v-checkbox
        v-model="checkbox2"
        :label="`Ecclesiastical`"
      ></v-checkbox>

      <v-checkbox
        v-model="checkbox3"
        :label="`Shared Churches`"
      ></v-checkbox>

      <v-checkbox
        v-model="checkbox4"
        :label="`New Churches Num. 1`"
      ></v-checkbox>

      <v-checkbox
        v-model="checkbox5"
        :label="`New Churches Num. 2`"
      ></v-checkbox>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
      class="text-white flex-grow-1 text-none"
              color="blue-darken-4"
              rounded="0"
              variant="flat"
        :text="isExpanded ? 'Close' : 'Manage Layers'"
        @click="isExpanded = !isExpanded"
        size="small"
        
      ></v-btn>

      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    // checkbox1: false,
    // checkbox2: false,
    isExpanded: false,
  }),

  computed: {    
    checkbox0: {
      get() {
        return this.getChb0;
      },
        
      set(val) {
        console.log("Value::", val);
        this.SET_LYR0(val);
        this.addLayer('esri-tiles')
      },
    },

    checkbox1: {
      get() {
        return this.getChb1;
      },
        
      set(val) {
        console.log("Value::", val);
        this.SET_LYR1(val);
        this.addLayer('politicalBndry')
      },
    },

    checkbox2: {
      get() {
        return this.getChb2;
      },      
      set(val) {
        console.log("Value::", val);
        this.SET_LYR2(val);
        this.addLayer('EssBndry')
      },
    },

    checkbox3: {
      get() {
        return this.getChb3;
      },      
      set(val) {
        console.log("Value::", val);
        this.SET_LYR3(val);
        this.addLayer('churchesA')
      },
    },

    checkbox4: {
      get() {
        return this.getChb4;
      },      
      set(val) {
        console.log("Value::", val);
        this.SET_LYR4(val);
        this.addLayer('churchesB')
      },
    },

    checkbox5: {
      get() {
        return this.getChb5;
      },      
      set(val) {
        console.log("Value::", val);
        this.SET_LYR5(val);
        this.addLayer('churchesC')
      },
    },


    ...mapState({
      statechb0: "chbEsriTiles",
      statechb1: "chbPolitical",
      statechb2: "chbEcc",
    }),
    ...mapGetters({
      getChb0: "getChb0",
      getChb1: "getChb1",
      getChb2: "getChb2",
      getChb3: "getChb3",
      getChb4: "getChb4",
      getChb5: "getChb5",
    }),
  },
  methods: {
    toggleExpanded() {
      isExpanded.value = !isExpanded.value;
    },

    ...mapMutations(["SET_LYR0","SET_LYR1","SET_LYR2","SET_LYR3","SET_LYR4","SET_LYR5"]),
    ...mapActions(['addLayer'])
  },
};
</script>
<style scoped>
.customPos {
  position: absolute;
  right: 20px;
  top: 73px;
}
.expanded {
  /* Add styles for the expanded state, like increased height */
  height: 260px; /* Adjust as needed */
}
>>>.v-input__details {
  display: none !important;
}

>>>.v-input__control {
  height: 32px;
}
</style>
